<script>
    import CRUD from './CRUD.svelte';
    import { onMount } from 'svelte';
    import { 
        fetchPrecios, 
        savePrecio, 
        removePrecio, 
        searchPrecios, 
        subscribeToPrecios, 
        unsubscribeFromPrecios 
    } from '../controllers/precioController.js';
    import { fetchSucursales } from '../controllers/sucursalController.js';

    // Configuración de las columnas para la tabla de precios
    let precioColumns = [
        { label: 'Nombre', field: 'nombre', type: 'text' },
        { label: 'Sucursal', field: 'sucursal', type: 'relation', relationField: 'descrip' },
        { label: 'Fórmula', field: 'formula', type: 'text' }
    ];

    // Estructura del nuevo objeto Precio
    let newPrecio = {
        nombre: '',
        sucursal: null, // Relación con la sucursal
        formula: '', // Fórmula del precio
        sta: true,
    };

    // Configuración de los campos para la edición de precios
    let editColumns = [
        { label: 'Sucursal', key: 'sucursal', type: 'select', required: true, fetchOptions: { key: 'id', value: 'descrip' }, options: [] },
        { label: 'Nombre', key: 'nombre', type: 'text', required: true },
        { label: 'Fórmula', key: 'formula', type: 'text', required: true },
    ];

    // Función para cargar y transformar sucursales
    let sucursalOptions = [];

    // Función para cargar y transformar sucursales
    async function loadSucursales() {
        try {
            const fetchedSucursales = await fetchSucursales();

            if (Array.isArray(fetchedSucursales.sucursal)) {
                sucursalOptions = fetchedSucursales.sucursal.map(e => ({
                    key: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.key],
                    value: e[editColumns.find(col => col.key === 'sucursal').fetchOptions.value],
                }));

                // Asigna las opciones transformadas a las columnas editables
                editColumns.find(column => column.key === 'sucursal').options = sucursalOptions;
            } else {
                console.error('Se esperaba un array de sucursales, pero se obtuvo:', fetchedSucursales);
            }
        } catch (error) {
            console.error('Error al cargar las sucursales:', error);
        }
    }

    // Cargar las sucursales al montar el componente
    onMount(() => {
        loadSucursales();
    });
</script>

<CRUD 
    title="Precios"
    entityName="precio"
    newEntity={newPrecio}
    columns={precioColumns}
    fetchEntities={fetchPrecios}
    saveEntity={savePrecio}
    removeEntity={removePrecio}
    searchEntities={searchPrecios}
    subscribeToChanges={subscribeToPrecios}
    unsubscribeFromChanges={unsubscribeFromPrecios}
    editColumns={editColumns}
/>
